import React from 'react';
import { RoutePermittedRole } from 'shared/constants/AppConst';
import ShuttleGuard from './ShuttleGuard';

const ShuttleMasters = React.lazy(() => import('./ShuttleMasters'));
const ShuttleMasterBuilder = React.lazy(() => import('./ShuttleMasterBuilder'));

export const ShuttleConfigs = [
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/shuttle/masters',
    element: <ShuttleGuard><ShuttleMasters /></ShuttleGuard>,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/shuttle/masters/create',
    element: <ShuttleGuard><ShuttleMasterBuilder mode='create' /></ShuttleGuard>,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/shuttle/masters/:id/edit',
    element: <ShuttleGuard><ShuttleMasterBuilder mode='edit' /></ShuttleGuard>,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/shuttle/masters/:id',
    element: <ShuttleGuard><ShuttleMasterBuilder mode='view' /></ShuttleGuard>,
  },
];
